import CommonOperationClass from '../../commonOperationClass';

const clean = new CommonOperationClass('C');

export default clean;
